import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MatchDetail } from "@app/core/match/domain/model/match-detail";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { MatchDetailMapper } from "@app/core/match/data/network/match-detail.mapper";

/**
 * Web service used to get match detail.
 */
@Injectable({
  providedIn: "root",
})
export class SharedStatisticsWS {
  constructor(private handler: BaseHandler) {}
  execute(playerId: string, token: string): Observable<MatchDetail> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.MATCH_SHARED_STATISTICS_ENDPOINT(playerId))
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.handler
      .execute(parameters)
      .pipe(map((response) => {
        return MatchDetailMapper.deserialize(response);
      }));
  }

  //Need this in the testing class sorry :S
  changeProvabilityOfLoadingSection(number: number) {}
}
